import script from "./PaymentAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentAccount.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentAccount.vue?vue&type=style&index=0&id=8714e068&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8714e068"]])

export default __exports__